const legacyTabToReactPath: Record<string, string> = {
    'management': 'managementControl/scorecard',
    'ownership': 'ownership/scorecard',
    'skillsdev': 'skillsdevelopment/scorecard',
    'enterprise': 'enterpriseDevelopment/scorecard',
    'sed': 'socioEconomicDevelopment/scorecard',
    'procurement': 'preferentialProcurement/scorecard',
    'rsm': 'rsm/scorecard',
    'empowermentFinancingAndESD': 'empowermentFinancing/scorecard',
    'propertyEconomicDevelopment': 'economicDevelopment/scorecard',
    'accessToFinancialServices': 'accessToFinancialServices/scorecard',
    'accessToFinancialServicesShortTerm': 'accessToFinancialServices/scorecard',
    'employment': 'employmentEquity/scorecard',
    'dashboard': 'summary/dashboard'
};

export function navigateToElementScorecard(baseLegacyRoute: string): (hash: string) => string | null {
    return (hash: string) => {
        const match = hash.match(/[#/]scorecard\/([^/?#]+)/);
        return match ? `/bee/scorecard/${match[1]}/${baseLegacyRoute}/scorecard` : null;
    };
}

export function legacyHashToReactRoute(hash: string): string | null {
    const match = hash.match(/[#/]scorecard\/([^/?#]+)\/([^/?#]+)/);
    if (!match) return null;

    const [, scorecardId, tab] = match;
    const reactPath = legacyTabToReactPath[tab];
    if (!reactPath) return null;

    return `/bee/scorecard/${scorecardId}/${reactPath}`;
}
